import { LitElement, html, css } from "lit";
import "./popin-wrapper.css"


/**
 * popin
 */
export class PopinWrapper extends LitElement {
    static properties = {
        isOpen: { type: Boolean },
        theme: { type: String }
    }
    /**
     * wrapper de la popin
     */
    constructor() {
        super();
        this.isOpen = false;
        this.theme = ""
    }

    connectedCallback() {
        super.connectedCallback()
    }

    /**
     * A chaque chamgement de propriétés
     * @param {*} changedProperties 
     */
    willUpdate(changedProperties) {
        super.update()
        if (changedProperties.has('isOpen')) {
            let content = this.shadowRoot.querySelector('popin-content');
            let button = this.shadowRoot.querySelector('popin-button')
            // button.removeEventListener('open-popin', this.openPopin.bind(this))
            button.addEventListener('open-popin', this.openPopin.bind(this))

            if (this.isOpen) {
                document.body.style.overflow = "hidden"
            }
            else {
                document.body.style.overflow = "auto"

            }
            const animationIn = [
                { opacity: 0, transform: "translateY(20px)" },
                { opacity: 1, transform: "translateY(0px)" }]

            if (content) {
                content.addEventListener('close-popin', this.closePopin.bind(this))
                content.animate(animationIn, { duration: 500, easing: "ease" })
            }

        }
    }

    /**
     * Changer l'état ouverte ou fermée de la popin
     * @param {Boolean} val 
     */
    setIsOpen(val) {
        this.isOpen = val
    }

    openPopin(e) {
        e.stopPropagation();
        this.setIsOpen(true)

    }

    closePopin(e) {
        e.stopPropagation();

        const animationOut = [
            { opacity: 1, transform: "translateY(0px)" },
            { opacity: 0, transform: "translateY(20px)" }
        ]

        this.shadowRoot.querySelector('popin-content').animate(animationOut, { easing: "ease", duration: 250 }).onfinish = () => this.setIsOpen(false)
    }

    render() {
        return html`
        <popin-button>
            <slot name="button"></slot>
        </popin-button>
        ${this.isOpen ? html`<popin-content theme=${this.theme}>
            <slot name="content"></slot>
        </popin-content>` : null}
        `
    }
}

export class PopinButton extends LitElement {
    static styles = css`
    :host{
           display:inline-block;
           padding : 1px;
           cursor: pointer;
        }
        `
    openPopin() {
        this.dispatchEvent(new CustomEvent('open-popin', { detail: { name: this.name } }))
    }

    render() {
        return html`
        <div @click=${this.openPopin}>
            <slot></slot>
        </div>
        `
    }
}

export class PopinContent extends LitElement {

    static properties = {
        theme: {}
    }

    static styles = css`
    :root{
        --popin-background: white;
        --popin-content-color : black;
    }

    :host{
        position:fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 30px;
        overflow: auto;
        display : block;
        z-index:1000;
        height:100vh;
    }

    .popin{
        background: var(--popin-background);
        color: var(--popin-content-color);
    }
    
    .dark{
        --popin-background : black;
        --popin-content-color: white;
    }
    .cross{
        fill : var(--popin-content-color);
    }
 
    .light{
        --popin-background : white;
        --popin-content-color: black;
        
    }

    .light .cross{
        fill : var(--popin-content-color, black);
    }

    .wrapper{
        position: relative;
        overflow: auto;
        height: 100vh;
    }

    .close{
        position:absolute;
        display:flex;
        right: 20px;
        top: 10px;
        z-index: 1;
        cursor: pointer;
        align-items: center;
        justifiy-align: center;
        padding:10px;
        transition: transform ease 150ms;
    }
    .close:hover{
        transform: scale(1.05);
    }

    .close span{
        padding-right: 5px;
    }

    .content{
        margin:40px;
    }
    `

    close(e) {
        e.stopPropagation()
        this.dispatchEvent(new CustomEvent('close-popin', { detail: { name: this.name } }))
    }

    render() {
        return html`
        <section class="${this.theme} popin">
            <div @click=${this.close} class="close">
                <span>fermer</span>
                <svg xmlns="http://www.w3.org/2000/svg" class="cross" width="14.143" height="14.142"
                    viewBox="0 0 14.143 14.142">
                    <path id="Union_1" data-name="Union 1"
                        d="M-4274.929-5664.221l-6.364,6.363-.708-.707,6.364-6.364-6.364-6.364.708-.708,6.364,6.364,6.364-6.364.708.708-6.364,6.364,6.364,6.364-.708.707Z"
                        transform="translate(4282 5672)" />
                </svg>
            </div>
            <div class="wrapper">
                <div class="content">
                    <slot></slot>
                </div>
            </div>
        </section>
                `
    }
}

customElements.define("popin-button", PopinButton)
customElements.define("popin-content", PopinContent)
customElements.define("popin-wrapper", PopinWrapper)

